import { makeStyles } from '@material-ui/core/styles';
import { TextColors, SurfaceColors, BackgroundColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  root: {
    color: TextColors.light,

    '& $filters': {
      '&.MuiAppBar-colorDefault': {
        background: BackgroundColors.dark,
        color: TextColors.light,

        '& .title': {
          color: hexToRGBA(TextColors.light, TextOpacities.light2),
        },
      },
    },

    '& $tab': {
      color: TextColors.light,
    },

    '& $tabIcon': {
      color: TextColors.light,
    },
  },
};

const lightTheme = {
  root: {
    color: TextColors.dark,

    '& $filters': {
      '&.MuiAppBar-colorDefault': {
        background: SurfaceColors.light,
        color: TextColors.dark,

        '& .title': {
          color: hexToRGBA(TextColors.dark, TextOpacities.dark2),
        },
      },
    },

    '& $tab': {
      color: TextColors.dark,
    },

    '& $tabIcon': {
      color: TextColors.dark,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,

      [muiTheme.breakpoints.down('sm')]: {
        width: '100%',
      },

      '&:not(.typography-small)': {
        '& $tab': {
          ...muiTheme.typography.body1,

          '& span': {
            fontWeight: 'bold',
          },
        },
      },

      '&.typography-small': {
        '& $tab': {
          ...muiTheme.typography.body2,

          '& span': {
            fontWeight: 'normal',
          },
        },
      },
    },
    filters: {
      '&.MuiAppBar-root': {
        alignItems: 'baseline',
        alignContent: 'baseline',
        display: 'flex',
        flexDirection: 'row',
        padding: muiTheme.spacing(2.375, 0, 1.875, 0),
        height: '61px',

        [muiTheme.breakpoints.down('sm')]: {
          width: '100%',
        },

        '& .title': {
          marginLeft: muiTheme.spacing(4),
        },
      },
    },
    tabs: {
      '&.MuiTabs-root': {
        minHeight: '27px',
        alignItems: 'baseline',
        width: '100%',

        '& .MuiTabScrollButton-root': {
          alignSelf: 'center',
          marginTop: '-3px',
          width: '32px',
        },

        '& .MuiTabs-indicator': {
          display: 'none',
        },
      },
    },
    tab: {
      '&.MuiTab-root': {
        minHeight: '27px',
        minWidth: 0,
        opacity: 1,
        padding: 0,

        '&:not(:first-child)': {
          marginLeft: muiTheme.spacing(1.25),
        },

        '&:not(:last-child)': {
          marginRight: muiTheme.spacing(1.25),
        },
      },
    },
    tabIcon: {
      verticalAlign: 'middle',
      display: 'inline-flex',
      marginLeft: '4px',
    },
    tabPanel: {
      padding: muiTheme.spacing(3, 4),
      backgroundColor: SurfaceColors.light,
    },
    tabPanelButton: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: muiTheme.spacing(3),
    },
    tabPanelTitle: {
      '&.MuiTypography-root': {
        color: TextColors.dark,
        marginBottom: muiTheme.spacing(2),
      },
    },
    tabPlaceholder: {
      display: 'none',
    },
  }),
  { name: 'GenElasticTabFilter' },
);

export default useStyles;
